/**
 * Chaves do localStorage de stores que saíram da loja e ainda estão no navegador de quem já a usava.
 * `payment-method-storage`: a escolha de pagamento (usePaymentMethodStore), nunca lida pela tela.
 */
export const LEGACY_STORAGE_KEYS = ['payment-method-storage'] as const

/** Apaga as chaves antigas (na casca da loja e no logout). Sem localStorage (bloqueado, servidor), não faz nada. */
export function removeLegacyStorage(): void {
    try {
        for (const key of LEGACY_STORAGE_KEYS) globalThis.localStorage?.removeItem(key)
    } catch {
        // Armazenamento bloqueado: não há o que apagar.
    }
}
